'use strict'

/**
 * Public projection for catalog rows on the canonical master-lot manifest.
 *
 * This dependency-neutral leaf is shared by master-lot internals and
 * cross-cluster consumers such as contract-switch preview.
 */

export function catalogEntriesFromManifest(manifest) {
  if (!manifest || typeof manifest !== 'object') return []
  return Array.isArray(manifest.catalogEntries) ? manifest.catalogEntries : []
}
